import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";

export interface MerchantOverrideItemRejectMessageProps {
  merchantCreatedPreRejectMessage: string;
}

export const MerchantOverrideItemRejectMessage = ({
  merchantCreatedPreRejectMessage,
}: MerchantOverrideItemRejectMessageProps) => {
  return (
    <Flex align="center" gap="xs">
      <RedoFeaturedIcon color="warning" Icon={AlertCircleIcon} size="xs" />
      <Text fontSize="xs" fontWeight="bold" textColor="disabled">
        {merchantCreatedPreRejectMessage}
      </Text>
    </Flex>
  );
};
